import { Controller } from "@hotwired/stimulus"
import { useStore } from "stimulus-store"
import { areaStore } from "../../stores/locales/area_store"

// Connects to data-controller="buttons--add-room-button"
export default class extends Controller {
    static stores = [areaStore]

    connect() {
        useStore(this)

        // Initialize button state
        this.initializeButtonState()
    }

    /**
     * React to area store changes to enable/disable button
     */
    onAreaStoreUpdate(newValue) {
        this.updateButtonState(newValue)
    }

    /**
     * Initialize button state on connect
     */
    initializeButtonState() {
        // Get current area state and update button
        const currentAreaStore = this.areaStoreValue
        this.updateButtonState(currentAreaStore)
    }

    /**
     * Update button state based on area selection
     */
    updateButtonState(areaStore) {
        const hasAreaSelected = areaStore && areaStore.id

        if (hasAreaSelected) {
            this.enableButton()
        } else {
            this.disableButton()
        }
    }

    /**
     * Enable button
     */
    enableButton() {
        // Enable the button
        this.element.disabled = false

        // Add Bootstrap modal attributes
        this.element.setAttribute('data-bs-toggle', 'modal')
        this.element.setAttribute('data-bs-target', '#locale-form-modal')
    }

    /**
     * Disable button
     */
    disableButton() {
        // Disable the button
        this.element.disabled = true

        // Remove Bootstrap modal attributes to prevent modal opening
        this.element.removeAttribute('data-bs-toggle')
        this.element.removeAttribute('data-bs-target')
    }
}